import angular from 'angular';
import { trim, get, head, isEmpty } from 'lodash';
import moment from 'moment-timezone';
import 'moment/locale/es';
import 'moment/locale/pt';
import '../../components/status';
import '../../services/subscription';
import '../../services/place';
import '../../services/line';
import '../../services/area';
import { formatAwt } from '../../utils';
import { setPriorityIcon, setTypeIcon } from '../../utils/subscriptionIcons';

const module = angular.module('whyline.modals.info', [
  'whyline.components.status',
  'whyline.services.subscription',
  'whyline.services.place',
  'whyline.services.line',
  'whyline.services.area',
]);

const InfoController = (
  $scope,
  $timeout,
  $uibModalInstance,
  SubscriptionService,
  PlaceService,
  LineService,
  AreaService,
  subscriptionId,
  currentPlaceId,
  waitingTime,
  $translate,
) => {
  'ngInject';

  $scope.forwardedData = null;
  $scope.showWaitingTime = false;
  $scope.showSubscriptionDates = false;
  $scope.currentPlace = PlaceService.GetOne(currentPlaceId);
  $scope.cancel = () => {
    $uibModalInstance.close('cancel');
  };

  const dismissOnError = (err) => {
    if ([401, 403, 404].indexOf(err.status) >= 0) {
      $uibModalInstance.close('cancel');
    }
  };

  $scope.place = PlaceService.GetCurrent();
  $scope.waitingTime = waitingTime;
  $scope.getShowName = SubscriptionService.getShowName;

  const getSubscriptionData = () => {
    // Initialize data
    $scope.user = {};
    $scope.subscription = {};

    // Get info of a subscription
    SubscriptionService.GetOneAsPromiseFromServer(subscriptionId)
      .then((res) => {
        $timeout(() => {
          // Check if a response was returned
          if (res) {
            // Check if is enqueued in an area
            if (res.areaId) {
              $scope.enqueuedInArea = AreaService.GetOne(res.areaId);
            }
            // Get a copy of the element
            $scope.subscription = SubscriptionService.Copy(res);

            // Get the current line of the subscription
            const line = LineService.GetOne(res.lineId);
            $scope.line = line;

            // Do format to times
            $scope.subscription.waitingTime = formatAwt(res.waitingTime);
            $scope.showWaitingTime = true;

            const lang = $translate.use();
            moment.locale(lang);

            $scope.openAt = moment();

            $scope.showName = $scope.getShowName($scope.subscription);

            // If forwarded, show previous queue
            if (get(head(res.movementsHistory), 'action', null) === 'forward') {
              $scope.forwardedData = res.movementsHistory[1];
            }

            $scope.showSubscriptionDates = true;

            $scope.subscription.showCompanyData = (
              !isEmpty(get($scope.subscription, 'onBehalfOf.companyCuit', '')) &&
              !isEmpty(get($scope.subscription, 'onBehalfOf.companyName', ''))
            );

            setTypeIcon($scope.subscription);
            setPriorityIcon($scope.subscription);
          }
        });
      })
      .catch(dismissOnError);
  };

  getSubscriptionData();

  $scope.updateSubscriptionData = getSubscriptionData;
};

module.exports = module.controller('InfoController', InfoController);
